import { useEffect, useState } from 'react';
import * as Sentry from '@sentry/react';
import AppDrawer from '../AppDrawer/AppDrawer';
import Error404Page from './Error404Page';
import { ENV } from '../../config';

function ErrorBoundary({ children, message = 'Please try again later', title = 'Something went wrong' }) {
  const [hasError, setHasError] = useState(false);
  Sentry.init({
    dsn: `${ENV === 'DEV' ? 'https://a7f2e79efaa6fbb64sentry.tools.hl1.in/8' : 'https://6b190994a8869ff4c1a73efa06a53c10@sentry.tools.hl1.in/17'}`,
    environment: `${ENV !== 'UAT' ? 'production' : 'staging'}`,
    // Performance Monitoring
    tracesSampleRate: 1.0, // Capture 100% of the transactions
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
  useEffect(() => {
    const handleError = (error, errorInfo) => {
      if (
        error
        && error.message
        && (error.message.includes('ResizeObserver loop') || error.message.includes('Script error.'))
      ) {
        console.warn('Ignoring specific error:', error.message);
      } else {
        // Capture the error in Sentry
        console.error(error, errorInfo);
        Sentry.captureException(error, { extra: errorInfo });
        setHasError(true);
      }
    };
    setHasError(false);

    window.addEventListener('error', handleError);

    return () => {
      window.removeEventListener('error', handleError);
    };
  }, [children]);

  if (hasError) {
    return (
      <>
        <AppDrawer permissions={{ read: true, write: true }} />
        <Error404Page
          title={title}
          message={message}
        />
      </>
    );
  }

  return children;
}

export default ErrorBoundary;
